import motionBlocks from '../block-vertical-blocks/motion';

export default function motionEntry(targetId, deviceInfo, blockSeparator) {
    let motionBlocksWithTarget = motionBlocks(targetId);

    return `
        ${deviceInfo.motorInfo.hasMotor ? `
            <category name="%{BKY_CATEGORY_MOTION}" id="motion" colour="#4C97FF" secondaryColour="#3373CC">
                ${motionBlocksWithTarget.motion_spin}
                ${motionBlocksWithTarget.motion_spindegree}
                ${motionBlocksWithTarget.motion_spinpositiondegree}
                ${blockSeparator}
                ${motionBlocksWithTarget.motion_stop}
                ${blockSeparator}
                ${motionBlocksWithTarget.motion_setpositiondegree}
                ${motionBlocksWithTarget.motion_setvelocitypercent_entry}
                ${motionBlocksWithTarget.motion_setstopping}
                ${motionBlocksWithTarget.motion_setmaxtorque}
                ${motionBlocksWithTarget.motion_settimeout}
            </category>` : ``
        }
    `;
};